module.exports = __webpack_public_path__ + "static/media/secure-badge.c03d3c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/secure-badge.png
// module id = 13900
// module chunks = 0